import { render, staticRenderFns } from "./TrustElements.vue?vue&type=template&id=130c2940&"
import script from "./TrustElements.vue?vue&type=script&lang=js&"
export * from "./TrustElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports